import React, { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

// Components
import Input from "../../../components/FormElements/Input";

//
import { updateProfileSchema } from "../../../utils/schemas/userSchema";
import UserMiddlewares from "../../../store/middlewares/UserMiddlewares";

const UpdateProfileForm = ({ initialValues }) => {
  const { t } = useTranslation();
  const form = useForm({
    resolver: yupResolver(updateProfileSchema),
  });
  const dispatch = useDispatch();
  const {
    handleSubmit,
    formState: { errors },
    setValue,
  } = form;

  useEffect(() => {
    if (initialValues) {
      const valueArray = Object.keys(initialValues);

      valueArray.forEach((val) => {
        if (!val) {
          return;
        }
        setValue(val, initialValues[val]);
      });
    }
  }, [initialValues]);

  const updateProfileHandler = (data) => {
    dispatch(UserMiddlewares.updateProfile({ ...data }));
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(updateProfileHandler)}>
        <Input
          label={t("signup.firstnameLabel")}
          id="firstname"
          name="firstname"
          placeholder=""
          marginBottom="sm"
          error={errors?.firstname?.message}
        />
        <Input
          label={t("signup.lastnameLabel")}
          id="lastname"
          name="lastname"
          placeholder=""
          marginBottom="sm"
          error={errors?.lastname?.message}
        />
        <Input
          label={t("signup.emailLabel")}
          id="email"
          name="email"
          placeholder=""
          marginBottom="sm"
          error={errors?.email?.message}
        />
        <div className="d-grid gap-2 my-3">
          <button
            type="submit"
            className="btn btn-primary">
              {t("profile.updateProfileLabel")}
          </button>
        </div>
      </form>
    </FormProvider>
  );
};

export default UpdateProfileForm;
